<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Lõpeta projekt</h3>
        </template>

        <template #right>
            <router-link :to="'/project/' + $route.params.projectUserId" class="btn-circle">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </router-link>
        </template>

        <div class="max-w-4xl mx-auto text-center">
            <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="my-8 md:my-12" />

            <h3 class="mb-5 text-2xl font-semibold">Oled kindel, et soovid projekti lõpetada?</h3>

            <div class="flex flex-wrap text-left -mx-4">
                <div class="w-full md:w-1/2 px-4">
                    <div class="flex items-center my-3">
                        <div>
                            <svg viewBox="0 0 80 80" fill="none" class="w-10 h-10 mr-3">
                                <path
                                    d="M25.2307 40.1819L33.6693 48.7006C34.4467 49.4853 35.707 49.4853 36.4844 48.7006L54.7692 30.2424"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M68 40C68 55.464 55.464 68 40 68C24.536 68 12 55.464 12 40C12 24.536 24.536 12 40 12C55.464 12 68 24.536 68 40Z"
                                    stroke="currentColor"
                                    stroke-width="3"
                                />
                            </svg>
                        </div>
                        <p>Projekti lõpetamisega makstakse projekteerijatele välja projektis seni tehtud ülesanded.</p>
                    </div>

                    <div class="flex items-center my-3">
                        <div>
                            <svg viewBox="0 0 80 80" fill="none" class="w-10 h-10 mr-3">
                                <path
                                    d="M68 40C68 55.464 55.464 68 40 68C24.536 68 12 55.464 12 40C12 24.536 24.536 12 40 12C55.464 12 68 24.536 68 40Z"
                                    stroke="currentColor"
                                    stroke-width="3"
                                />
                                <path
                                    d="M39.9678 24V47"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M39.9678 53.6001V55.2001"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <p>Projekti taaskäivitamiseks peab saavutama uue kokkuleppe või uue meeskonnaga.</p>
                    </div>
                </div>

                <div class="w-full md:w-1/2 px-4">
                    <div class="flex items-center my-3">
                        <div>
                            <svg viewBox="0 0 80 80" fill="none" class="w-10 h-10 mr-3">
                                <path
                                    d="M68 40C68 55.464 55.464 68 40 68C24.536 68 12 55.464 12 40C12 24.536 24.536 12 40 12C55.464 12 68 24.536 68 40Z"
                                    stroke="currentColor"
                                    stroke-width="3"
                                />
                                <path
                                    d="M39.9678 24V47"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M39.9678 53.6001V55.2001"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <p>Projekti taaskäivitamisel uue meeskonna poolt võib tehtud töö osutuda kasutuks.</p>
                    </div>

                    <div class="flex items-center my-3">
                        <div>
                            <svg viewBox="0 0 80 80" fill="none" class="w-10 h-10 mr-3">
                                <path
                                    d="M68 40C68 55.464 55.464 68 40 68C24.536 68 12 55.464 12 40C12 24.536 24.536 12 40 12C55.464 12 68 24.536 68 40Z"
                                    stroke="currentColor"
                                    stroke-width="3"
                                />
                                <path
                                    d="M39.9678 24V47"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M39.9678 53.6001V55.2001"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <p>Projekti ootamatu lõpetamine võib mõjuda halvasti tellija reitingule.</p>
                    </div>
                </div>
            </div>

            <button
                @click="endProject"
                class="w-full sm:w-72 mt-12 text-white bg-orange-400 btn xs:w-64 md:mt-20"
            >Lõpeta projekt
            </button>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import {end} from "@/store/project.api";

export default {
    components: {
        FramedLayout
    },
    data() {
        return {
            //
        }
    },
    methods: {
        endProject() {
          end(this.$route.params.projectUserId).then(({data}) => {
            this.$router.push(`/project/${this.$route.params.projectUserId}`);
            setTimeout(() => {
              this.processAxiosPositiveResponse(data);
            }, 100)
          });
        },
    }
}
</script>
